import { IsoDate, IsoDateTime, IsoDateTimeTz, IsoTime, IsoTimeTz } from '../../types/iso-date';
import { assertDatesForComparision } from '../helper/assert-dates-for-comparision.function';

/**
 * Returns true if a is before b (chronologically).
 * Accepts ISO date/time strings (date, time, datetime, with/without timezone).
 * Throws for invalid input.
 */
export function isBefore<T extends IsoDate | IsoDateTime | IsoDateTimeTz | IsoTime | IsoTimeTz>(a: T, b: T): boolean {
  const [da, db] = assertDatesForComparision(a, b);
  return da.getTime() < db.getTime();
}

